"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'messaging';
exports.SET_GLOBAL_MESSAGE = exports.namespace + "/SET_GLOBAL_MESSAGE";
//# sourceMappingURL=constants.js.map